module.exports = __webpack_public_path__ + "static/img/waiting_approve_cod_wallet.707383d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/waiting_approve_cod_wallet.png
// module id = 2mS8
// module chunks = 134